import { Logger } from '../types';
import { Console } from './console';

@Console()
export class ClientLogger extends Logger {}
